
import React, { useState, useEffect } from 'react';
import { Bike } from 'lucide-react';

const DeliveryBikeAnimation: React.FC = () => {
  const [bikePosition, setBikePosition] = useState(-50); // Starting off-screen
  
  useEffect(() => {
    // Animate the delivery bike across the screen
    let position = -50;
    const bikeAnimation = setInterval(() => {
      position += 2;
      setBikePosition(position);
      
      // Reset the bike position once it goes off screen
      if (position > window.innerWidth) {
        position = -50;
        setBikePosition(position);
      }
    }, 30);
    
    return () => {
      clearInterval(bikeAnimation);
    };
  }, []);

  return (
    <div 
      className="absolute top-1 z-10 transition-all duration-300 flex items-center drop-shadow-md" 
      style={{ 
        left: `${bikePosition}px`,
        transform: 'scale(0.8)',
      }}
    >
      <div className="relative">
        <div className="absolute -top-12 -left-4 bg-white rounded-full p-1 shadow-md">
          <div className="text-xs font-bold text-ahavex-blue whitespace-nowrap">Fast Delivery!</div>
        </div>
        <div className="flex items-center gap-0">
          <div className="relative">
            <Bike 
              size={32} 
              className="text-ahavex-blue animate-bounce" 
              style={{ 
                filter: 'drop-shadow(2px 2px 2px rgba(0,0,0,0.3))',
              }}
            />
            <div className="absolute -top-4 -right-1 w-5 h-5 bg-ahavex-blue rounded-full flex items-center justify-center">
              <div className="w-4 h-4 bg-white rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-ahavex-blue rounded-full"></div>
              </div>
            </div>
            <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-ahavex-blue rounded-full flex items-center justify-center">
              <div className="w-5 h-5 bg-white rounded-full flex items-center justify-center">
                <div className="w-3 h-3 bg-ahavex-blue rounded-full"></div>
              </div>
            </div>
          </div>
          <div className="w-3 h-8 bg-ahavex-blue rounded-l-full"></div>
        </div>
      </div>
      <div className="h-1 w-10 bg-gray-400/30 absolute -bottom-1 left-2 rounded-full animate-pulse"></div>
    </div>
  );
};

export default DeliveryBikeAnimation;
